import type { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useLayoutEffect } from 'react';

import { FAQBlock } from '../components/landingV4/FAQBlock';
import { FeedbackBlock } from '../components/landingV4/FeedbackBlock';
import { Footer } from '../components/landingV4/Footer';
import { Header } from '../components/landingV4/Header';
import { SnackbarProvider } from '../components/landingV4/SnackbarProvider';
import { WhySgGlobalCoverageBlock } from '../components/landingV4/WhySgGlobalCoverageBlock';
import { WhySgHero } from '../components/landingV4/WhySgHero';
import { WhySgSecurityBlock } from '../components/landingV4/WhySgSecurityBlock';
import { WhySgSmartRoutingBlock } from '../components/landingV4/WhySgSmartRoutingBlock';
import { WhySgTimeToMarketBlock } from '../components/landingV4/WhySgTimeToMarketBlock';
import { EmptyLayout } from '../components/layout/MainLayout/EmptyLayout';

import { NextPageWithLayout } from './_app';

const Page: NextPageWithLayout = () => {
  useLayoutEffect(() => {
    document.documentElement.classList.add('v4');
    document.documentElement.style.setProperty('--background', '#09090B');

    return () => {
      document.documentElement.classList.remove('v4');
      document.documentElement.style.removeProperty('--background');
    };
  }, []);

  return (
    <SnackbarProvider>
      <Head>
        <title>Why SmartGate | SmartGates</title>
        <meta
          name="description"
          content="Scale your business with an intelligent data-driven payment ecosystem — security, smart routing and unified analytics."
        />
      </Head>

      <Header />
      <WhySgHero />
      <WhySgSmartRoutingBlock />
      <WhySgSecurityBlock />
      <WhySgTimeToMarketBlock />
      <WhySgGlobalCoverageBlock />
      <FAQBlock />
      <FeedbackBlock />
      <Footer />
    </SnackbarProvider>
  );
};

Page.getLayout = (page) => <EmptyLayout withFloatMenu={false}>{page}</EmptyLayout>;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', ['common'])),
    },
  };
};

export default Page;
